import { HttpClient } from "@angular/common/http";
import { Version } from "src/app/models/version";
import { apiLocations } from "../../../environments/app.config.json";

export function getVersion(httpClient: HttpClient) {
  return httpClient.get<Version>(`${apiLocations.base}/apiversion/get-version`);
}
